const parentescos = [
  {
    id: "1",
    parentesco: "Papá"
  },
  {
    id: "2",
    parentesco: "Mamá"
  },
  {
    id: "3",
    parentesco: "Hermano"
  },
  {
    id: "4",
    parentesco: "Tio"
  },
  {
    id: "5",
    parentesco: "Abuelo"
  },
  {
    id: "6",
    parentesco: "Primo"
  },
  {
    id: "7",
    parentesco: "Padrino"
  },
  {
    id: "8",
    parentesco: "Familiar Cercano"
  },
  {
    id: "9",
    parentesco: "Amigo"
  },
  {
    id: "10",
    parentesco: "Vecino"
  },
  {
    id: "11",
    parentesco: "Padrastro - Madrastra"
  },
  {
    id: "12",
    parentesco: "Sustituto"
  },
  {
    id: "13",
    parentesco: "El mismo estudiante"
  }
]
export default parentescos